<template>
    <marketing-automation-form-panel-section :title="$t('message.automation.message.filters')">
        <v-select  class="padding"
                   v-model="selectedGenders"
                   :items="formattedGenderLabel"
                   multiple
                   chips
                   :label="$t('message.automation.message.selectGender')"
                    @input="emitChange('genderFilter', $event)">

        </v-select>

        <app-range-slider class="slider padding"
                          :value="[val.initialAge, val.finalAge]"
                          :readonly="readonly"
                          :data-label="$t('message.campaigns.message.yearsOld')"
                          @input="sliderInput">

        </app-range-slider>

        <extra-fields-filter  v-if="isNotExternalDatabase"
                              :value="val.extraFields"
                              @change="emitExtraFieldsValues"/>

        <use-terms-filter v-if="isNotExternalDatabase"
                          :value="val.useTerms"
                          @input="emitUseTermsValues"/>                      
    </marketing-automation-form-panel-section>
</template>
<script>
import MarketingAutomationFormPanelSection
    from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection";
import UseTermsFilter from "@components/filters/UseTermsFilter.vue";    
import AppRangeSlider from "@components/RangeSlider";
import ExtraFieldsFilter from "@components/filters/ExtraFieldsFilter";
import vModel from "@mixins/v-model";
import {cloneDeep} from "lodash";


export default {
    components: {
        MarketingAutomationFormPanelSection,
        ExtraFieldsFilter,
        AppRangeSlider,
        UseTermsFilter
    },


    data() {
        return {        
          selectedGenders: [],
        };
    },

    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default() {
                return {
                    initialAge: 0,
                    finalAge: 100,
                    genderFilter: undefined,
                    extraFields: [],
                    useTerms: []
                };
            },
        },
        isNotExternalDatabase: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        formattedGenderLabel() {
            return this.genderOptions.map(item => item.label)
        },
        genderOptions() {
            return [
            { value: "FEMININO", label: this.$t('message.campaigns.message.women') },
              { value: "MASCULINO", label: this.$t('message.campaigns.message.men') },
              { value: "NAO_INFORMADO", label: this.$t('message.generics.message.notInformed') },
            ]
        },

    },

    methods: {
        sliderInput(evt) {
            this.val.initialAge = evt[0];
            this.val.finalAge = evt[1];

            this.$emit("input", this.val);
        },
        emitChange(key, val) {
            const value = cloneDeep(this.val);
            const newArray = val.map(item => {
                switch (item) {
                    case this.$t('message.campaigns.message.women'):
                        item = 0;
                        break;
                    case this.$t('message.campaigns.message.men'):
                        item = 1;
                        break;
                    case this.$t('message.generics.message.notInformed'):
                        item = 2;
                        break;
                    default:
                        break;
                }
                return item
            })
            value[key] = [...new Set(newArray)];
            this.$emit("input", value);
        },
        emitExtraFieldsValues(value) {
            this.val.extraFields = [...value]
            this.$emit('select', this.val)
        },
        emitUseTermsValues(value) {
            this.val.useTerms = [...value]
            this.$emit('setUseTerms', this.val)
        }
    },

    mounted() {
        this.val.genderFilter.map(item => {
            if(item === "FEMININO")
                this.selectedGenders.push(this.$t('message.campaigns.message.women'))
            if(item === "MASCULINO")
                this.selectedGenders.push(this.$t('message.campaigns.message.men'))
            if(item === 'NAO_DECLARADO')
                this.selectedGenders.push(this.$t('message.generics.message.notInformed'))
        })
    },

    mixins: [vModel]

}
</script>

<style>
    .marketing-automation-form-panel-entry-section-select {
        margin: 0 auto;
    }

    .slider {
        margin-bottom: 20px;
    }

    .padding {
        padding: 0 10px
    }
</style>
